import {
  STARTER_PLAN_OVERRIDE,
  IS_ISTA_USER,
  ROLE_PREVIEW_OVERRIDE,
  SESSION_ACCESS_TOKEN,
  SESSION_EXPIRES_AT,
  SESSION_USER_EMAIL,
} from '../constants/localStorage';

import { ISTA_QUERY_PARAM } from '../constants/auth';

const ISTA_EMAIL_DOMAIN = '@ista.';

export const getSessionExpirationTimestamp = (): number => {
  return parseInt(localStorage.getItem(SESSION_EXPIRES_AT), 10);
};
export const beforeFirstAuthentication = (timestamp: number): boolean => {
  return isNaN(timestamp);
};
export const removeSessionStorage = (): void => {
  localStorage.removeItem(SESSION_ACCESS_TOKEN);
  localStorage.removeItem(SESSION_EXPIRES_AT);
  localStorage.removeItem(SESSION_USER_EMAIL);
  // The preview overrides are scoped to a session, not to the browser: they must not outlive
  // the person who set them. On a shared support/QA laptop the next user would otherwise
  // inherit a seat and a commercial tier they do not have. Cleared here rather than at
  // login because logout is the only point we are guaranteed to reach on the way out.
  localStorage.removeItem(STARTER_PLAN_OVERRIDE);
  localStorage.removeItem(ROLE_PREVIEW_OVERRIDE);
};

export const setIsIstaUser = (email: string): void => {
  if (email?.includes(ISTA_EMAIL_DOMAIN)) {
    localStorage.setItem(IS_ISTA_USER, 'true');
  }
};

export const getIstaQueryParams = (queryParamType?: string): { t: 'ista' } | null => {
  // Check if the current URL has the 'ista' query param or if the user was previously identified as an ISTA user
  if (queryParamType === 'ista' || localStorage.getItem(IS_ISTA_USER) === 'true') {
    return ISTA_QUERY_PARAM;
  }
  return null;
};
